import { render } from "./title-with-underline.vue?vue&type=template&id=c725f52c&scoped=true"
import script from "./title-with-underline.vue?vue&type=script&lang=js"
export * from "./title-with-underline.vue?vue&type=script&lang=js"

import "./title-with-underline.vue?vue&type=style&index=0&id=c725f52c&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c725f52c"]])

export default __exports__